export const AB_TESTS = {
  TofuCartSummaryRedesign: "tofuCartSummaryRedesign",
  SocialAuth: "socialAuth",
  SkinSetFlexibility: "skinSetFlexibility", // skin set flexibility experiment RG-9
  LongTermDiscounts: "longTermDiscounts", // long term discounted "plans" experiment RG-8
  OrderPriceBreakdown: "orderPriceBreakdown", // Request new formula experiment RG-114
  ChurnPreventionMessageDoctor: "churnPreventionMessageDoctor", // Churn prevention tactic message doctor experiment RG-236
  ChurnPreventionPause: "churnPreventionPause", // Churn prevention pause experiment RG-256
  ChurnPreventionSuccessStories: "churnPreventionSuccessStories", // Churn prevention pause experiment 269
  SubscriptionTiers: "subscriptionTiersAg633", // Subscription Tiers experiment AG-356 / AG-633
  // TODO: change this to MoreInfoClaIntro
  MoreInfoClaIntro: "moreInfoClaIntro", // CLA hide AYD experiment RG-292
  MoreInfoClaWelcome: "moreInfoClaWelcome", // CLA hide AYD experiment RG-294
  MoreInfoClaWelcomeHideAyd: "moreInfoClaWelcomeHideAyd", // CLA hide AYD experiment RG-294 + RG-296
  AydFAQs: "aydFAQs", // CLA FAQs within AYD experiment RG-298
  PlanSelectionStorylineImprovement: "planSelectionStorylineImprovement",
  ImprovedOnboarding: "improvedOnboarding", // CLA extended improved onboarding experience RG-308 (pre-treatment plan)
  PersonalizedTreatment: "claPersonalizedTreatmentRg351", // CLA personalized treatment journey experiment RG-351 (post-treatment plan)
  SignupStepRedesign: "signupStepRedesignAg609", // A/B test: Signup step redesign AG-609
  ImprovedPatientFeedback: "improvedPatientFeedbackRg372", // CLA improved patient feedback experiment RG-372 (post-treatment plan)
} as const

export type AB_TESTS_OPTIONS = (typeof AB_TESTS)[keyof typeof AB_TESTS]

export enum ClaCustomerMetadataKeys {
  improvedOnboardingExperiment = "cla_improvedOnboarding_experiment",
  personalizedTreatmentExperiment = "cla_personalizedTreatment_experiment",
  improvedPatientFeedbackExperiment = "cla_improvedFeedback_experiment_rg372",
}

export type ClaCustomerExperimentMetadataKeys =
  (typeof ClaCustomerMetadataKeys)[keyof typeof ClaCustomerMetadataKeys]

export const AB_TESTS_DATA: {
  [key in AB_TESTS_OPTIONS]: {
    lsKey: string
    campaignURL?: string
    deactivated?: boolean
    routes?: Record<string, string>
    cleanupLsKeys?: string[] // If the test is deactivated, AbTestContainer will remove these keys from localStorage
    experimentMetadataKey?: ClaCustomerMetadataKeys // All experiments that rely on customer metadata should have this key set correctly
  }
} = {
  [AB_TESTS.TofuCartSummaryRedesign]: {
    lsKey: `__vwo__${AB_TESTS.TofuCartSummaryRedesign}`,
    deactivated: false,
  },
  [AB_TESTS.SocialAuth]: {
    lsKey: `__vwo__${AB_TESTS.SocialAuth}`,
    deactivated: false,
  },
  [AB_TESTS.SkinSetFlexibility]: {
    lsKey: `__vwo__${AB_TESTS.SkinSetFlexibility}`,
    campaignURL: `/vwo/${AB_TESTS.SkinSetFlexibility}`,
  },
  [AB_TESTS.LongTermDiscounts]: {
    lsKey: `__vwo__${AB_TESTS.LongTermDiscounts}`,
    campaignURL: `/vwo/${AB_TESTS.LongTermDiscounts}`,
  },
  [AB_TESTS.OrderPriceBreakdown]: {
    lsKey: `__vwo__${AB_TESTS.OrderPriceBreakdown}`,
    deactivated: true,
    cleanupLsKeys: [`__vwo__${AB_TESTS.OrderPriceBreakdown}`],
  },
  [AB_TESTS.ChurnPreventionMessageDoctor]: {
    lsKey: `__vwo__${AB_TESTS.ChurnPreventionMessageDoctor}`,
    deactivated: true,
    cleanupLsKeys: [`__vwo__${AB_TESTS.ChurnPreventionMessageDoctor}`],
  },
  [AB_TESTS.ChurnPreventionPause]: {
    lsKey: `__vwo__${AB_TESTS.ChurnPreventionPause}`,
    deactivated: true,
    cleanupLsKeys: [`__vwo__${AB_TESTS.ChurnPreventionPause}`],
  },
  [AB_TESTS.ChurnPreventionSuccessStories]: {
    lsKey: `__vwo__${AB_TESTS.ChurnPreventionSuccessStories}`,
    // campaignURL: `/vwo/${AB_TESTS.ChurnPreventionSuccessStories}`,
    deactivated: false,
  },
  [AB_TESTS.SubscriptionTiers]: {
    lsKey: `__vwo__${AB_TESTS.SubscriptionTiers}`,
    deactivated: false,
    cleanupLsKeys: [
      `__vwo__${AB_TESTS.SubscriptionTiers}`,
      `__vwo__${AB_TESTS.SubscriptionTiers}_running`,
      "__vwo__testPresetType",
    ],
  },
  [AB_TESTS.MoreInfoClaIntro]: {
    lsKey: `__vwo__${AB_TESTS.MoreInfoClaIntro}`,
    deactivated: false,
  },
  [AB_TESTS.MoreInfoClaWelcome]: {
    lsKey: `__vwo__${AB_TESTS.MoreInfoClaWelcome}`,
    deactivated: false,
  },
  [AB_TESTS.MoreInfoClaWelcomeHideAyd]: {
    lsKey: `__vwo__${AB_TESTS.MoreInfoClaWelcomeHideAyd}`,
    deactivated: false,
  },
  [AB_TESTS.AydFAQs]: {
    lsKey: `__vwo__${AB_TESTS.AydFAQs}`,
    deactivated: false,
  },
  [AB_TESTS.PlanSelectionStorylineImprovement]: {
    lsKey: `__vwo__${AB_TESTS.PlanSelectionStorylineImprovement}`,
    deactivated: true,
    cleanupLsKeys: [
      `__vwo__${AB_TESTS.PlanSelectionStorylineImprovement}`,
      `__vwo__${AB_TESTS.PlanSelectionStorylineImprovement}_running`,
    ],
  },
  [AB_TESTS.ImprovedOnboarding]: {
    lsKey: `__vwo__${AB_TESTS.ImprovedOnboarding}`,
    deactivated: false,
  },
  [AB_TESTS.PersonalizedTreatment]: {
    lsKey: `__vwo__${AB_TESTS.PersonalizedTreatment}`,
    deactivated: false,
  },
  [AB_TESTS.SignupStepRedesign]: {
    lsKey: `__vwo__${AB_TESTS.SignupStepRedesign}`,
    deactivated: true,
    cleanupLsKeys: [`__vwo__${AB_TESTS.SignupStepRedesign}_running`],
  },
  [AB_TESTS.ImprovedPatientFeedback]: {
    lsKey: `__vwo__${AB_TESTS.ImprovedPatientFeedback}`,
    deactivated: false,
    experimentMetadataKey:
      ClaCustomerMetadataKeys.improvedPatientFeedbackExperiment,
  },
}
